function initMap() {
  var defaultZoom = 8;
  var defaultPos = {
    lat: 51.11991,
    lng: -0.7932975101563216
  };
  var map = new google.maps.Map(document.getElementById('map'), {
    center: defaultPos,
    zoom: defaultZoom,
    scrollwheel: false,
    styles: [
      {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "-100"
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "lightness": 65
          },
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "lightness": "50"
          },
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "-100"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
          {
            "lightness": "30"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
          {
            "lightness": "40"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "hue": "#ffff00"
          },
          {
            "lightness": -25
          },
          {
            "saturation": -97
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
          {
            "lightness": -25
          },
          {
            "saturation": -100
          }
        ]
      }
    ]
  });

  setMarkers(map);

  function setMarkers(map) {
    var image = {
      url: '/img/logo/w-device.png',
      size: new google.maps.Size(100, 100),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 25),
      scaledSize: new google.maps.Size(50, 50)
    };

    var offices = [
      ['Bournemouth', 50.722387644963106, -1.8792542156052936, 4, '<div id="content"><div id="siteNotice"></div><div id="bodyContent"><p>56-58 Richmond Hill<br>Bournemouth<br>Dorset<br>BH2 6EX<br><br><a href="https://www.google.com/maps/place/Weissman/@50.722374,-1.8814462,17z/data=!3m2!4b1!5s0x4873a1c15c826727:0x47028a683e4f6e5b!4m5!3m4!1s0x4873a1c4022ad4f5:0xfa744e78aaa6a9e8!8m2!3d50.7223706!4d-1.8792522" rel="nofollow noreferrer noopener" target="_blank">Get directions</a></p></div></div>'],
      ['London', 51.51851314517993, -0.14221064724131596, 5, '<div id="content"><div id="siteNotice"></div><div id="bodyContent"><p>85 Great Portland Street<br>London<br>Greater London<br>W1W 7LT<br><br><a href="https://www.google.co.uk/maps/dir//85+Great+Portland+St,+Marylebone,+London+W1W+7LT/@51.5184885,-0.1444194,17z/data=!4m16!1m7!3m6!1s0x48761ad59616a0d3:0x8028b376bec1fbe7!2s85+Great+Portland+St,+Marylebone,+London+W1W+7LT!3b1!8m2!3d51.5184885!4d-0.1422307!4m7!1m0!1m5!1m1!1s0x48761ad59616a0d3:0x8028b376bec1fbe7!2m2!1d-0.1422307!2d51.5184885" rel="nofollow noreferrer noopener" target="_blank">Get directions</a></p></div></div>']
    ];

    for (var i = 0; i < offices.length; i++) {
      var office = offices[i];

      var marker = new google.maps.Marker({
        position: {lat: office[1], lng: office[2]},
        map: map,
        icon: image,
        title: office[0],
        zIndex: office[3]
      });

      marker.infowindow = new google.maps.InfoWindow({
        content: office[4]
      });

      marker.addListener('click', function(e) {
        if (map.zoom == defaultZoom) {
          map.setZoom(18);
          map.setCenter(this.getPosition());
          this.infowindow.open(map, this);
        } else {
          map.setZoom(defaultZoom);
          map.setCenter(defaultPos);
          this.infowindow.close();
        }
      });
    }
  }
}
